import * as actions from "../actions/Type";
const intialState = {
  newest_sell_contracts: [],
  newest_rent_contracts: [],
  newest_rent_property: [],
  newest_sell_property: [],
  newest_takemoney_contract: [],
  count_avilable_property: [],
  count_total_money: [],
  count_total_Scontract: [],
  count_total_Rcontract: [],
  rent_sell_chart_contract: [],
  sell_Vertital_chart_contract: [],
  rent_Vertital_chart_contract: [],
  required_count: "",
};
const DashboardReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.NEWEST_AVILABLE_RENT_PROPERTY:
      return {
        ...state,
        newest_rent_property: action.payload,
      };
    case actions.NEWEST_AVILABLE_SELL_PROPERTY:
      return {
        ...state,
        newest_sell_property: action.payload,
      };
    case actions.NEWEST_CONTRACT_RENT:
      return {
        ...state,
        newest_rent_contracts: action.payload,
      };
    case actions.NEWEST_CONTRACT_SELL:
      return {
        ...state,
        newest_sell_contracts: action.payload,
      };

    case actions.NEWEST_TAKEMONEY_CONTRACT:
      return {
        ...state,
        newest_takemoney_contract: action.payload,
      };
    case actions.COUNT_PROPERTY:
      return {
        ...state,
        count_avilable_property: action.payload,
      };

    case actions.TOTAL_MONEY_SALES:
      return {
        ...state,
        count_total_money: action.payload,
      };
    case actions.COUNT_RENT_CONTRACT:
      return {
        ...state,
        count_total_Rcontract: action.payload,
      };
    case actions.COUNT_SELL_CONTRACT:
      return {
        ...state,
        count_total_Scontract: action.payload,
      };
    case actions.SELL_RENT_CONTRACT_CHART:
      return {
        ...state,
        rent_sell_chart_contract: action.payload,
      };
    case actions.SELL_RENT_CONTRACT_CHART_VERTICAL:
      return {
        ...state,
        sell_Vertital_chart_contract: action.payload,
      };
    case actions.RENT_CONTRACT_CHART_VERTICAL:
      return {
        ...state,
        rent_Vertital_chart_contract: action.payload,
      };
    case actions.COUNT_REQUIRED:
      return {
        ...state,
        required_count: action.payload,
      };
    default:
      return { ...state };
  }
};

export default DashboardReducer;
